export default (value, { yesText='YES', noText='NO', nullText='UNKNOWN' }={}) => {
    return ((value === null) || (typeof value === 'undefined')) ? nullText : (value ? yesText : noText);
};
